import { createAsyncThunk } from "@reduxjs/toolkit";
import { isJson } from "Libs/utils";

import { getOrganizationSubscriptionAlertRequest } from "Api/organizations/subscriptionAlert/getOrganizationSubscriptionAlert.request";
import logger from "Libs/logger";
import { organizationByDescriptionIdSelector } from "Reducers/organization/organization";
import { selectSubscriptionDetails as organizationSubscriptionSelector } from "Reducers/organization/subscription";

import type { OrganizationSubscriptionAlert } from "Api/organizations/subscriptionAlert/types";
import type { AsyncThunkOptionType } from "Reducers/types";

export const getSubscriptionAlert = createAsyncThunk<
  OrganizationSubscriptionAlert,
  {
    organizationDescriptionId: string;
    subscriptionId: string;
  },
  AsyncThunkOptionType
>(
  "app/organization/subscriptionAlert/get",
  async (
    { organizationDescriptionId, subscriptionId },
    { rejectWithValue, getState }
  ) => {
    try {
      const organization = organizationByDescriptionIdSelector(getState(), {
        organizationDescriptionId
      });

      return await getOrganizationSubscriptionAlertRequest({
        organizationId: organization!.id,
        subscriptionId
      });
    } catch (_error: any) {
      const error = isJson(_error) ? JSON.parse(_error) : _error;

      const err = error.detail || error.details || error.message;
      logger(err, {
        action: "get_subscription_alert"
      });
      return rejectWithValue(err);
    }
  },
  {
    condition: (
      { organizationDescriptionId, subscriptionId },
      { getState }
    ) => {
      const subscription = organizationSubscriptionSelector(getState(), {
        organizationId: organizationDescriptionId,
        subscriptionId
      });

      return !!subscription?._links?.view_usage_alerts;
    }
  }
);
